import { AmplitudeFlagType } from 'types/amplitudeFlags';

import useExperiment from './useExperiment';

const useExperimentValue = (experimentName: AmplitudeFlagType): string | null => {
  const experiment = useExperiment();

  return experiment.getVariantValue(experimentName);
};

export default useExperimentValue;
